import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-cau-chuyen-cua-cnh",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./cau-chuyen-cua-cnh.component.html",
  styleUrl: "./cau-chuyen-cua-cnh.component.scss",
})
export class CauChuyenCuaCNHComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  goHomeAndScrollTop(): void {
    this.router.navigateByUrl("/").then(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
}